import { cdnImage, cdnSrcSet } from "../utils/cdnImage";

/* Снимка на продукт: смалена от Cloudinary, в лек формат и в няколко ширини,
   за да вземе телефонът малката, а големият екран — голямата.
   ratio (височина / ширина) изрязва около най-важното в снимката;
   без ratio снимката остава цяла (страницата на продукта). */
export const ProductImage = ({ src, alt = "", widths = [300, 600], ratio, sizes, ...rest }) => {
  const largest = widths[widths.length - 1];
  const srcSet = cdnSrcSet(src, widths, ratio);
  return (
    <img
      src={cdnImage(src, ratio ? { w: largest, h: Math.round(largest * ratio) } : { w: largest })}
      srcSet={srcSet}
      sizes={srcSet ? sizes : undefined}
      alt={alt}
      {...rest}
    />
  );
};
